import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  table: {
    width: '50%',
    margin: 20
  },
  title: {
    textAlign: 'center',
    borderBottom: '1px solid #E6E6EC',
    padding: 20,
    '& h6': {
      fontSize: 14,
      fontWeight: 'bold',
      color: '#6D7278',
      textTransform: 'uppercase'
    }
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #E6E6EC',
    padding: '0 95px 0 20px'
  },
  buttonConfirm: {
    textDecoration: 'underline'
  },
  addButtonContainer: {
    textAlign: 'center'
  },
  addButton: {
    margin: '20px auto',
    fontFamily: 'PT sans',
    fontSize: '16px',
    textTransform: 'lowercase',
    fontWeight: 'bold',
    borderColor: '#002380',
    borderRadius: 0,
    minWidth: '145px'
  }
}));

const ValuationTable = ({ title, rows, textButton }) => {
  const classes = useStyles();

  return (
    <div className={classes.table}>
      <div className={classes.title}>
        <h6>{title}</h6>
      </div>
      {rows.map((row) => (
        <div className={classes.row}>
          <h6>{row}</h6>
          <Button className={classes.buttonConfirm} color="primary">
            Confirm
          </Button>
        </div>
      ))}
    </div>
  );
};

export default ValuationTable;
